"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpMethod = void 0;
/**
 * HTTP request methods.
 *
 * HTTP defines a set of request methods to indicate the desired action to be
 * performed for a given resource. Although they can also be nouns, these
 * request methods are sometimes referred as HTTP verbs. Each of them implements
 * a different semantic, but some common features are shared by a group of them:
 * e.g. a request method can be safe, idempotent, or cacheable.
 *
 */
let HttpMethod = exports.HttpMethod = /*#__PURE__*/function (HttpMethod) {
  /**
   * The `CONNECT` method establishes a tunnel to the server identified by the
   * target resource.
   */
  HttpMethod["Connect"] = "connect";
  /**
   * The `DELETE` method deletes the specified resource.
   */
  HttpMethod["Delete"] = "delete";
  /**
   * The `GET` method requests a representation of the specified resource.
   * Requests using GET should only retrieve data.
   */
  HttpMethod["Get"] = "get";
  /**
   * The `HEAD` method asks for a response identical to that of a GET request,
   * but without the response body.
   */
  HttpMethod["Head"] = "head";
  /**
   * The `OPTIONS` method is used to describe the communication options for the
   * target resource.
   */
  HttpMethod["Options"] = "options";
  /**
   * The PATCH method is used to apply partial modifications to a resource.
   */
  HttpMethod["Patch"] = "patch";
  /**
   * The `POST` method is used to submit an entity to the specified resource,
   * often causing a change in state or side effects on the server.
   */
  HttpMethod["Post"] = "post";
  /**
   * The `PUT` method replaces all current representations of the target
   * resource with the request payload.
   */
  HttpMethod["Put"] = "put";
  /**
   * The `TRACE` method performs a message loop-back test along the path to the
   * target resource.
   */
  HttpMethod["Trace"] = "trace";
  return HttpMethod;
}({});
//# sourceMappingURL=HttpMethod.js.map